import { useState } from 'react';
import * as React from 'react';
import gettext from '@sdk/lang/gettext';
import { Attachment } from '@sdk/attachments/types';
import Row from '@sdk/components/ui/spacing/Row';
import Checkbox from '@sdk/components/forms/Checkbox';
import Text14 from '@sdk/components/ui/typography/Text14';
import Clickable from '@sdk/components/primitives/Clickable';

import TextEditorModal, {
  Props as TextEditorModalProps,
} from '@web/richText/TextEditorModal/TextEditorModal';
import TitleIcon from '@web/assets/svg/Icons/32/newsfeed-blue.svg';

type Props = {
  initialSticky: boolean;
  pageName: string;
  onSubmit?: (contentObj: { text: string; attachments: Attachment[]; sticky: boolean }) => void;
} & TextEditorModalProps;

const EditArticleModal: React.FC<React.PropsWithChildren<Props>> = ({
  onSubmit,
  initialSticky,
  pageName,
  ...props
}) => {
  const [isSticky, setIsSticky] = useState(initialSticky);

  const submit = (contentObj: { text: string; attachments: Attachment[] }): void => {
    onSubmit({ ...contentObj, sticky: isSticky });
  };

  const renderStickyControl = (): JSX.Element => (
    <Row mTop={10}>
      <Checkbox value={isSticky} onChange={setIsSticky} />
      <Clickable onClick={(): void => setIsSticky(!isSticky)}>
        <Text14 mLeft={10}>{gettext('Pin to top of page %(pageName)s', { pageName })}</Text14>
      </Clickable>
    </Row>
  );

  return (
    <TextEditorModal
      {...props}
      titleText={gettext('Edit post')}
      titleIcon={<TitleIcon />}
      onSubmit={submit}
      postContent={renderStickyControl()}
    />
  );
};

export default EditArticleModal;
